import React, { useState } from 'react'
import { NavLink, Link } from "react-router-dom";
import { IoCloseOutline, IoMenuOutline } from "react-icons/io5";
import Logo from '../../Assets/LogoDark.png';
import LogoBig from '../../Assets/LogoBig.png';

const Navbar = () => {
    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);    
  return (
    <nav className='navbar'>
       <div className="navbar-container container">
       <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                <img className='header-logo' src={LogoBig} alt="Logo" />
            </Link>
            <div className="menu-icon" onClick={handleClick}>
              {click ? <IoCloseOutline /> : <IoMenuOutline />}
            </div>
            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    "nav-links" + (isActive ? " activated" : "")
                  }
                  onClick={closeMobileMenu}
                >
                  Acceuil
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/how-it-works"
                  className={({ isActive }) =>
                    "nav-links" + (isActive ? " activated" : "")
                  }
                  onClick={closeMobileMenu}
                >
                  Télécharger
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/how-it-works"
                  className={({ isActive }) =>
                    "nav-links" + (isActive ? " activated" : "")
                  }
                  onClick={closeMobileMenu}
                >
                  Guides
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/connexion"
                  className={({ isActive }) =>
                    "nav-links" + (isActive ? " activated" : "")
                  }
                  onClick={closeMobileMenu}
                >
                  Connexion
                </NavLink>
              </li>           
              <button className="nav-button">
                <NavLink 
                  to="/inscription"
                  className={({ isActive }) =>
                    "nav-links" + (isActive ? " activated" : "")
                  }
                  onClick={closeMobileMenu}
                >
                    <p className='nav-button-link'> S'inscrire</p>
                  
                </NavLink>
              </button>                           
            </ul>
          </div>        
    </nav>
  )
}

export default Navbar